import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const router = new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    mode: 'history',
    routes: [
        {
            path: '/payment',
            name: 'PaymentDetail',
            component: () => import('@/views/PaymentDetail')
        },
        {
            path: '/creditcard',
            name: 'CreditCard',
            component: () => import('@/views/CreditCard')
        },
        {
            path: '/qr',
            name: 'QR',
            component: () => import('@/views/QrPromptpay')
        }
    ]
    })
export default router
